import { arrayToMap } from "utils/custom.utils"

export const ORDER_TYPES = [
  {
    id: "T0",
    name: "General Order",
  },
  {
    id: "T1",
    name: "Resale Order",
  },
  {
    id: "T2",
    name: "Extra Order",
  },
  {
    id: "T3",
    name: "Resale Approval Order",
  },
  {
    id: "T4",
    name: "Dump Approval Order",
  },
  {
    id: "T6",
    name: "Consolidated Order",
  },
  {
    id: "T7",
    name: "Wholesale Order",
  },
  {
    id: "T8",
    name: "Consignment Order",
  },
]

export const ORDER_TYPES_MAP = arrayToMap(ORDER_TYPES)
